function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { StimulusUse } from '../stimulus_use';
import { method } from '../support/index';
export var UseTargetMutation = /*#__PURE__*/function (_StimulusUse) {
  _inherits(UseTargetMutation, _StimulusUse);

  var _super = _createSuper(UseTargetMutation);

  function UseTargetMutation(controller) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, UseTargetMutation);

    _this = _super.call(this, controller, options);

    _this.observe = function () {
      _this.observer.observe(_this.targetElement, {
        subtree: true,
        characterData: true,
        childList: true,
        attributes: true,
        attributeOldValue: true,
        attributeFilter: [_this.targetSelector, _this.scopedTargetSelector]
      });
    };

    _this.unobserve = function () {
      _this.observer.disconnect();
    };

    _this.mutation = function (entries) {
      var _iterator = _createForOfIteratorHelper(entries),
          _step;

      try {
        var _loop = function _loop() {
          var mutation = _step.value;

          switch (mutation.type) {
            case 'attributes':
              var newValue = mutation.target.getAttribute(mutation.attributeName);
              var oldValue = mutation.oldValue; // If this was an attribute change, and the attribute change resulted in a target changing

              if (mutation.attributeName === _this.targetSelector || mutation.attributeName === _this.scopedTargetSelector) {
                // Filter out any targets that don't belong to this controller
                var oldTargets = _this.targetsUsedByThisController(oldValue);

                var newTargets = _this.targetsUsedByThisController(newValue);

                var removedTargets = oldTargets.filter(function (target) {
                  return !newTargets.includes(target);
                }); // Get only the oldTargets that dont occur in newTargets, thus, removed

                var addedTargets = newTargets.filter(function (target) {
                  return !oldTargets.includes(target);
                }); // Get only the newTargets that dont occur in oldTargets - thus, added
                // Fire updates for each changed target on the controller

                removedTargets.forEach(function (target) {
                  return _this.targetRemoved(_this.stripIdentifierPrefix(target), mutation.target, 'attributeChange');
                });
                addedTargets.forEach(function (target) {
                  return _this.targetAdded(_this.stripIdentifierPrefix(target), mutation.target, 'attributeChange');
                });
              }

              break;

            case 'characterData':
              var nodule = _this.findTargetInAncestry(mutation.target);

              if (nodule == null) {
                return {
                  v: void 0
                };
              } else {
                var supportedTargets = _this.targetsUsedByThisControllerFromNode(nodule);

                supportedTargets.forEach(function (target) {
                  _this.targetChanged(_this.stripIdentifierPrefix(target), nodule, 'domMutation');
                });
              }

              break;

            case 'childList':
              var addedNodes = mutation.addedNodes,
                  removedNodes = mutation.removedNodes;
              addedNodes.forEach(function (node) {
                return _this.processNodeDOMMutation(node, _this.targetAdded);
              });
              removedNodes.forEach(function (node) {
                return _this.processNodeDOMMutation(node, _this.targetRemoved);
              });
              break;
          }
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _ret = _loop();

          if (_typeof(_ret) === "object") return _ret.v;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    _this.controller = controller;
    _this.options = options;
    _this.targetElement = controller.element;
    _this.identifier = controller.scope.identifier;
    _this.identifierPrefix = "".concat(_this.identifier, ".");
    _this.targetSelector = controller.scope.schema.targetAttribute;
    _this.scopedTargetSelector = "data-".concat(_this.identifier, "-target"); //TODO: If/When stimulus 2.0 adds the identifier scoped targetAttribute to the schema, use that here instead
    // @ts-ignore

    _this.targets = options.targets || controller.constructor.targets;
    _this.prefixedTargets = _this.targets.map(function (target) {
      return "".concat(_this.identifierPrefix).concat(target);
    });
    _this.observer = new MutationObserver(_this.mutation);

    _this.enhanceController();

    _this.observe();

    return _this;
  }

  _createClass(UseTargetMutation, [{
    key: "processNodeDOMMutation",
    value: function processNodeDOMMutation(node, initialChangeModeAssumption) {
      var _this2 = this;

      var nodule = node;
      var change = initialChangeModeAssumption;
      var supportedTargets = [];

      if (nodule.nodeName == '#text' || this.targetsUsedByThisControllerFromNode(nodule).length == 0) {
        change = this.targetChanged;
        nodule = this.findTargetInAncestry(node);
      } else {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }

      if (nodule == null) {
        return;
      } else if (supportedTargets.length == 0) {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      }

      supportedTargets.forEach(function (target) {
        change.call(_this2, _this2.stripIdentifierPrefix(target), nodule, 'domMutation');
      });
    }
  }, {
    key: "findTargetInAncestry",
    value: function findTargetInAncestry(node) {
      var nodule = node;
      var supportedTargets = [];

      if (nodule.nodeName != '#text') {
        supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);
      } else {} // Traverse up the node tree until we find a target, or the controller root element


      while (nodule.parentNode !== null && nodule.parentNode != this.targetElement && supportedTargets.length == 0) {
        nodule = nodule.parentNode;

        if (nodule.nodeName !== '#text') {
          var _supportedTargets = this.targetsUsedByThisControllerFromNode(nodule);

          if (_supportedTargets.length > 0) {
            // If this node has one of the watched targets on it, it's the one we want
            return nodule;
          } else {}
        }
      }

      if (nodule.nodeName == '#text') {
        return null;
      }

      if (nodule.parentNode == null) {
        return null;
      }

      if (nodule.parentNode == this.targetElement) {
        // Double and triple check that we aren't throwing away a target just because it's parent is the controller root
        if (this.targetsUsedByThisControllerFromNode(nodule).length > 0) {
          return nodule;
        }

        return null;
      }

      return null;
    }
  }, {
    key: "targetAdded",
    value: function targetAdded(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetAdded");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log('targetAdded', {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetRemoved",
    value: function targetRemoved(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetRemoved");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log('targetRemoved', {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetChanged",
    value: function targetChanged(name, node, trigger) {
      var targetCallback = "".concat(name, "TargetChanged");
      this.controller[targetCallback] && method(this.controller, targetCallback).call(this.controller, node);
      this.log('targetChanged', {
        target: name,
        node: node,
        trigger: trigger
      });
    }
  }, {
    key: "targetsUsedByThisControllerFromNode",
    value: function targetsUsedByThisControllerFromNode(node) {
      if (node.nodeName == "#text") {
        // Failsafe, just in case we try processing a text node
        return [];
      } // Extracts from the node, the target string, targetsUsedByThisController filters it, returns the array of supported target names


      var nodeElement = node;
      return this.targetsUsedByThisController(nodeElement.getAttribute(this.scopedTargetSelector) || nodeElement.getAttribute(this.targetSelector));
    }
  }, {
    key: "targetsUsedByThisController",
    value: function targetsUsedByThisController(targetStr) {
      // Filters out any targets that don't belong to this  controller and returns the array of supported target names
      targetStr = targetStr || '';
      var targetsToCheck = this.stripIdentifierPrefix(targetStr).split(' ');
      return this.targets.filter(function (n) {
        return targetsToCheck.indexOf(n) !== -1;
      });
    }
  }, {
    key: "stripIdentifierPrefix",
    value: function stripIdentifierPrefix(target) {
      return target.replace(new RegExp(this.identifierPrefix, 'g'), '');
    }
  }, {
    key: "enhanceController",
    value: function enhanceController() {
      var _this3 = this;

      var controllerDisconnect = this.controller.disconnect.bind(this.controller);

      var disconnect = function disconnect() {
        _this3.unobserve();

        controllerDisconnect();
      };

      Object.assign(this.controller, {
        disconnect: disconnect
      });
    }
  }]);

  return UseTargetMutation;
}(StimulusUse);
export var useTargetMutation = function useTargetMutation(controller) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var observer = new UseTargetMutation(controller, options);
  return [observer.observe, observer.unobserve];
};